if (!Enum) {
    var Enum = {};
}

Enum.E_REFERRAL_TYPE = {
    DIAGNOSTIC_OR_SPECIALIST_CARE: 'DIAGNOSTIC_OR_SPECIALIST_CARE',
    REFERRAL_NOTE: 'REFERRAL_NOTE',
    TRANSFER_OF_CARE: 'TRANSFER_OF_CARE'
};

Object.freeze(Enum.E_REFERRAL_TYPE);
